import React from 'react';
import classnames from 'classnames';
import { Icon } from '../icon';

import styles from './language-picker.module.scss';

export type LanguagePickerProps = {
  className?: string;
  hiddenLabel: string;
  id: string;
  'aria-label'?: string;
  options: { title: string; value: string }[];
} & Pick<React.SelectHTMLAttributes<HTMLSelectElement>, 'name' | 'value' | 'onChange'>;

const baseClass = 'language-picker';

export const LanguagePicker = React.forwardRef<HTMLSelectElement, LanguagePickerProps>(
  ({ className, id, hiddenLabel, 'aria-label': ariaLabel, options, name, value, onChange }, ref) => {
    const classes = classnames(styles[baseClass], className);
    const labelId = `${id}_label`;

    console.warn(`
      ⚠️ ### THIS COMPONENT IS DEPRECATED AND WILL BE REPLACE BY A PROPER DROPDOWN COMPONENT SOON ### ⚠️
      ⚠️ ### THIS COMPONENT IS DEPRECATED AND WILL BE REPLACE BY A PROPER DROPDOWN COMPONENT SOON ### ⚠️
      ⚠️ ### THIS COMPONENT IS DEPRECATED AND WILL BE REPLACE BY A PROPER DROPDOWN COMPONENT SOON ### ⚠️
      ⚠️ ### THIS COMPONENT IS DEPRECATED AND WILL BE REPLACE BY A PROPER DROPDOWN COMPONENT SOON ### ⚠️
      ⚠️ ### THIS COMPONENT IS DEPRECATED AND WILL BE REPLACE BY A PROPER DROPDOWN COMPONENT SOON ### ⚠️
    `);

    return (
      <div className={classes} data-testid="language-picker-component">
        <select
          id={id}
          ref={ref}
          value={value}
          name={name}
          onChange={onChange}
          aria-label={ariaLabel}
          className={styles[`${baseClass}__select`]}
        >
          {options.map((option, i) => (
            <option key={option.title + i} value={option.value}>
              {option.title}
            </option>
          ))}
        </select>
        {hiddenLabel && (
          <label htmlFor={id} id={labelId} className={styles[`${baseClass}__visually-hidden`]}>
            {hiddenLabel}
          </label>
        )}
        <Icon name="chevron-down--medium" aria-hidden className={styles[`${baseClass}__icon`]} />
      </div>
    );
  }
);

LanguagePicker.displayName = 'LanguagePicker';
